import axios from "axios";
import "./style.css";
import React, { useEffect, useState, useRef } from "react";
import { BiSearch } from "react-icons/bi";
import loadConfig from "../../Services/apiService";
import "./style.css";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export default function AllDropDownsAHSF(props) {
  const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState(props.defaultValue || "");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [textList, setTextList] = useState("");
  const [valueList, setValueList] = useState("");
  const [showOptions, setShowOptions] = useState(false);
  const [valueEdite, setValueEdite] = useState(props.valueEdite);
  const [textEdite, setTextEdite] = useState(props.textEdite);
  const inputRef = useRef(null);
  const [dataJsonObject, SetDataJsonObject] = useState();

  //[,]
  //this function to get data from main.json file by fieldsName props
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
    let fieldsName = props.fieldsName;
    let code = jsonData[fieldsName];
    SetDataJsonObject(code);
  };

  useEffect(() => {
    dataJson();
  }, []);
  //////////////////////// search props/////////////////////////
  // dropdownType="search"
  //  KeyText="text"
  // arrayOoptionList =[data]
  // validationMessage=""

  ///////////////////////////////////////////////////////////////

  ////////////////////////normal props///////////////////////////

  //////////////////////////////////////////////////////////////

  // props :
  //     dropdownType="search"
  //     show={true}
  //     title="dropdown"

  //
  //     id="dropdown2"
  //     name="Search Dropdown"
  //     clear={false}
  //     redOnly={false}
  //     submissionStatus="add"
  //     OnClickLi={(option) => //console.log(option)}
  //     showValidationMessage={false}
  //     validationMessage="*هذا الحقل اجباري"
  //     url="https://jsonplaceholder.typicode.com/posts"
  // defaultValue="3"
  useEffect(() => {
    const interval = setInterval(() => {
      if (inputRef.current) {
        inputRef.current.setAttribute("readonly", props.redOnly);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (props.dropdownType === "normal") {
      // axios
      //   .get(props.url)
      //   .then((response) => {
      //     const data = response.data
      //       .slice(0, 3)
      //       .map((option) => ({ value: option.id, label: option.title }));
      //     setOptions(data);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    } else {
      setOptions(props.arrayOoptionList);
      setFilteredOptions(props.arrayOoptionList);
    }
  }, [props.url, props.dropdownType, props.arrayOoptionList]);

  useEffect(() => {
    if (props.clear) {
      if (props.dropdownType === "normal") {
        setSelectedValue("");
      } else {
        setTextList("");
        setValueList("");
        setValueEdite("");
        setTextEdite("");
        setFilteredOptions(props.arrayOoptionList);

        setOptions(props.arrayOoptionList);
      }
    }
    //console.log(textEdite, "valueEdite");
  }, [props.clear, props.arrayOoptionList, props.dropdownType]);

  const handleSelectChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const handleInputChange = (e) => {
    let value = e.target.value;

    var arabicNormChar = {
      ك: "ک",
      ﻷ: "لا",
      ؤ: "و",
      ى: "ی",
      ي: "ی",
      ئ: "ی",
      أ: "ا",
      إ: "ا",
      آ: "ا",
      ٱ: "ا",
      ٳ: "ا",
      ة: "ه",
      ء: "",
      "ِ": "",
      "ْ": "",
      "ُ": "",
      "َ": "",
      "ّ": "",
      "ٍ": "",
      "ً": "",
      "ٌ": "",
      "ٓ": "",
      "ٰ": "",
      "ٔ": "",
      " ": "",
    };

    const simplifyArabic = (value) => {
      return value
        .replace(/[^\u0000-\u007E]/g, function (option) {
          var retval = arabicNormChar[option];

          if (retval == undefined) {
            retval = option;
          }
          return retval;
        })
        .normalize("NFKD")
        .toLowerCase();
    };

    setFilteredOptions(
      options.filter((option) => {
        return simplifyArabic(option[props.KeyText]).includes(
          simplifyArabic(value)
        );
      })
    );
  };

  const handleInputClick = () => {
    if (!props.redOnly) {
      setShowOptions((prevShowOptions) => !prevShowOptions);
    }
  };

  const handleClickOutside = (e) => {
    if (
      inputRef.current &&
      !inputRef.current.contains(e.target) &&
      e.target.className !== "inputSearch_"
    ) {
      setShowOptions(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  //console.log(filteredOptions, "sdsdsdscederfdgfdgf");

  return dataJsonObject ? (
    <>
      {props.show && (
        <div className="dropDownContainer" dropId={props.dropId}>
          {props.dropdownType === "normal" ? (
            <>
              {props.hidelable ? (
                ""
              ) : props.labelName ? (
                <label for={props.labelName} title={props.labelName}>
                  {props.labelName}
                  {props.labelName ? <span>*</span> : ""}
                  {props.showValidationMessage && (
                    <span
                      className="validation-icon2"
                      data-tooltip={props.validationMessage}
                    >
                      <FontAwesomeIcon icon={faCircleExclamation} />
                      &nbsp;
                    </span>
                  )}
                </label>
              ) : (
                <label for={dataJsonObject.code} title={dataJsonObject.nameEN}>
                  {dataJsonObject.nameAR}
                  {dataJsonObject.isRequired ? <span>*</span> : ""}
                  {props.showValidationMessage && (
                    <span
                      className="validation-icon2"
                      data-tooltip={props.validationMessage}
                    >
                      <FontAwesomeIcon icon={faCircleExclamation} />
                      &nbsp;
                    </span>
                  )}
                </label>
              )}

              <select
                id={dataJsonObject.code}
                // value={props.clear ? "" : props.value}
                onChange={props.onChange}
                onBlur={props.onBlur}
                required={props.required}
                disabled={props.disabled}
                defaultValue={props.defaultValue}
                title={props.title}
                className={props.showValidationMessage ? "input-error" : ""}
              >
                {!props.defaultValue && (
                  <option
                    selected={props.value == null ? true : false}
                    disabled
                  >
                    -- إختار --
                  </option>
                )}
                {props.arrayOoptionList?.map((option, index) => (
                  <option
                    selected={
                      props.value == option[props.KeyValue] ? true : false
                    }
                    key={index}
                    value={option[props.KeyValue]}
                  >
                    {option[props.KeyText]}
                  </option>
                ))}
              </select>

              {/* {props.showValidationMessage && (
                <p className="error-message">{props.validationMessage}</p>
              )} */}
            </>
          ) : (
            <div className="main">
              <div className="input-container">
                <input
                  id={props.id}
                  value={
                    props.submissionStatus === "edite" ? valueEdite : valueList
                  }
                  type="hidden"
                />
                {!props.hidelable ? (
                  <label
                    for={dataJsonObject[props.fieldsName]?.code}
                    title={dataJsonObject[props.fieldsName]?.nameEN}
                  >
                    {dataJsonObject[props.fieldsName]?.nameAR}
                    {dataJsonObject[props.fieldsName]?.isRequired == "true" ? (
                      <span> * </span>
                    ) : (
                      ""
                    )}
                    {props.showValidationMessage && (
                      <span
                        className="validation-icon"
                        data-tooltip={props.validationMessage}
                      >
                        <FontAwesomeIcon icon={faCircleExclamation} />
                        &nbsp;
                      </span>
                    )}
                  </label>
                ) : (
                  ""
                )}
                <input
                  id={dataJsonObject.CODE}
                  placeholder="اختيار...."
                  type="text"
                  title={props.title}
                  readOnly
                  disabled={props.disabled}
                  value={
                    props.clear
                      ? ""
                      : props.submissionStatus === "edite"
                      ? textEdite
                      : textList
                  }
                  onClick={handleInputClick}
                  ref={inputRef}
                  className={`form-select ${
                    props.showValidationMessage ? "" : ""
                  }`}
                />
              </div>
              {showOptions && (
                <ul className="list-group options">
                  {!props.yesNo && (
                    <li
                      className="inputsearchList"
                      onClick={() => setShowOptions(true)}
                    >
                      <div className="SearchIcons">
                        <BiSearch />
                      </div>
                      <input
                        onChange={handleInputChange}
                        className="inputSearch_"
                      />
                    </li>
                  )}
                  {filteredOptions.map((option, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        setFilteredOptions(props.arrayOoptionList);
                        props.OnClickLi(option);
                        if (props.submissionStatus === "edite") {
                          setValueEdite(option[props.id]);
                          setTextEdite(option[props.KeyText]);
                        } else {
                          setTextList(option[props.KeyText]);
                          setValueList(option[props.id]);
                        }
                      }}
                    >
                      {option[props.KeyText]}
                    </li>
                  ))}
                </ul>
              )}
              {/* {props.showValidationMessage && (
                <p className="error-message">{props.validationMessage}</p>
              )} */}
            </div>
          )}
        </div>
      )}
    </>
  ) : (
    ""
  );
}
